import { useState } from "react";
import { useContext, useEffect } from "react";
import { success } from "../../../../components/alertMessagesHandler/alert";
import CButton from "../../../../components/buttons/Button";
import CEmailField from "../../../../components/inputBoxes/email-input";
import CTextField from "../../../../components/inputBoxes/text-input";
import CTextAreaField from "../../../../components/inputBoxes/textArea-input";
import { LoadingContext } from "../../../../context/loadingContext";
import { contactFormHook } from "../hooks/contactUsHooks";

const DashboardContactUs = () => {
  const { setLoading } = useContext(LoadingContext);
  const [contactfield, setContactField] = useState({});

  useEffect(() => {
    setLoading(true);
    if (window.innerWidth <= 992)
      document.getElementById("sidebarToggle").click();
    setLoading(false);
  }, []);

  // Send email using contactFormHook

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const result = await contactFormHook(contactfield);
    setLoading(false);
    if (result.status === 200) success(result.message);
  };

  const HandleInputs = (name, value) => {
    setContactField({
      ...contactfield,
      [name]: value,
    });
  };
  return (
    <>
      <div className="row">
        <h4 className="text-dark mb-5 fw-bolder">Contact Us</h4>
        <div className="col-md-4 col-sm-12">
          <form onSubmit={submit}>
            <CEmailField
              required={true}
              customClassDiv={"mb-4"}
              customClassInput={"bg-primary-soft"}
              labelName={"Email"}
              name={"email"}
              placeholder={"12345678@gmail.com"}
              customClassLabel={"text-dark"}
              functionName={(name, value) => HandleInputs(name, value)}
            />
            <CTextField
              required={true}
              labelName={"Subject"}
              name={"subject"}
              customClassDiv={"mb-4 text-dark"}
              customClassInput={"bg-primary-soft"}
              functionName={(name, value) => HandleInputs(name, value)}
            />
            <CTextAreaField
              labelName={"Message"}
              name={"message"}
              required={true}
              rowsTextArea={6}
              customClassDiv={"mb-5 text-dark"}
              customClassInput={"bg-primary-soft"}
              functionName={(name, value) => HandleInputs(name, value)}
            />
            <CButton
              btnClassesDiv={"mb-4 text-center"}
              btnClasses={"btn px-4 fw-bold text-white"}
              IsOutline={false}
              innertext={"Send"}
              btnCustomStyle={{
                backgroundColor: "#044389",
              }}
            />
          </form>
        </div>
        <div className="col-md-8 col-sm-12"></div>
      </div>
    </>
  );
};

export default DashboardContactUs;
